export const sensitiveWorkforceUrl = url => /\/(goal-imports|compensation|planned-roster|workforce|sales-ramp\/user-start-dates)(?:\/|\?|$)/.test(String(url || ''));

const privateRequests = new Set();
export const workforceRecordingOptions = {
    dom: {privateAttributeBlocklist: ['data-private']},
    network: {
        requestSanitizer: request => {
            if (!sensitiveWorkforceUrl(request.url) && !(request.method?.toUpperCase() === 'POST' && /amazonaws\.com/.test(request.url || ''))) return request;
            privateRequests.add(request.reqId);
            return null;
        },
        responseSanitizer: response => {
            const hidden = privateRequests.delete(response.reqId) || sensitiveWorkforceUrl(response.url);
            return hidden ? null : response;
        },
    },
};
